import styles from './Proposta.module.css'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
} from '@mui/material'
import { TextFieldComponent } from '@/components/TextFieldComponent'
import 'react-quill/dist/quill.snow.css'
import { useEffect, useRef, useState } from 'react'
import { VerPropostaComponente } from '@/components/VerPropostaComponente'
import { EnviarImagensComponente } from '@/components/EnviarImagensComponente'
import AddIcon from '@mui/icons-material/Add'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined'
import WarningIcon from '@mui/icons-material/Warning';
import { StyledQuill } from './quill'
import { CustomSnackbar, severityType } from '../../../../utils/alert'
import CircularProgress from "@mui/material/CircularProgress";
import { ConfirmModal } from '@/components/ConfirmModal';
import { VivaTextField } from '../TextField/TextField'
import DOMPurify from 'dompurify'
import { usePropostaContext } from '@/contexts/PropostaContext'
import { ActionType } from '@/contexts/PropostaContext/actions'
import { PropostaFinanceira } from '../PropostaFinanceira/PropostaFinanceira'


interface PropostaProps {
  idAtendimento: string;
  propostaAtivaId?: number | null;
}

export function Proposta({ idAtendimento, propostaAtivaId }: PropostaProps) {
  const {
    state,
    acoes: {
      buscarPropostas,
      salvarProposta,
      iniciarNovaProposta,
      atualizarCampo,
      enviarPropostaParaCliente,
      deletarProposta,
      confirmarPagamento,
    },
    dispatch,
  } = usePropostaContext();  

  const alteracaoManualImagens = useRef(false);

  const [isSaving, setIsSaving] = useState(false);

  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [isSending, setIsSending] = useState(false);

  const [openModalAviso, setOpenModalAviso] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
  const handleOpenConfirmDeleteModal = () => {
    setOpenConfirmDeleteModal(true);
  }
  const handleCloseConfirmDeleteModal = () => {
    setOpenConfirmDeleteModal(false);
  }
  const handleConfirmDelete = async () => {
    if (state.proposta.id) {
      await deletarProposta(state.proposta.id);
      await buscarPropostas(idAtendimento, undefined);
      setAlertInfo({ severity: 'success', message: 'Proposta excluída com sucesso!' });
      setShowAlert(true);
    } else {
      setAlertInfo({ severity: 'error', message: 'Erro ao excluir a proposta.' });
      setShowAlert(true);
    }
    setOpenConfirmDeleteModal(false);
  }  

  const [openConfirmPaymentModal, setOpenConfirmPaymentModal] = useState(false);
  const handleClickOpenConfirmPaymentModal = () => {
    setOpenConfirmPaymentModal(true);
  }
  const handleCloseConfirmPaymentModal = () => {
    setOpenConfirmPaymentModal(false);
    setPagamentoTipoErro(false);
  }

  const [pagamentoTipo, setPagamentoTipo] = useState('');
  const [pagamentoTipoErro, setPagamentoTipoErro] = useState(false);


  const [propostaAtivaLocalId, setPropostaAtivaLocalId] = useState<number | null>(propostaAtivaId ?? null);

  const [showAlert, setShowAlert] = useState(false);
  const [alertInfo, setAlertInfo] = useState<{ severity: severityType; message: string }>({ severity: 'success', message: '' });
  const handleAlertClose = () => {
    setShowAlert(false);
  };


  const handleSalvarProposta = async () => {
  
    setIsSaving(true);
    const propostaSalvaId = await salvarProposta(state);
    if (propostaSalvaId) {
      await buscarPropostas(idAtendimento, propostaSalvaId);
      setPropostaAtivaLocalId(propostaSalvaId);
      setAlertInfo({ severity: 'success', message: 'Proposta salva com sucesso!' });
    } else {
      setAlertInfo({ severity: 'error', message: 'Erro ao salvar a proposta. Verifique os dados.' });
    }
  
    setShowAlert(true);
    setIsSaving(false);
  };  

  const handleClickOpenConfirmModal = () => {
    setOpenConfirmModal(true);
  };

  const handleCloseConfirmModal = () => {
    setOpenConfirmModal(false);
  }

  const handleConfirmarEnvio = async () => {
    try{
      setIsSending(true);
      const propostaId = state.proposta.id;

      

      if (propostaId) {
        const envioProposta = await enviarPropostaParaCliente(idAtendimento, {resumo: state.proposta.resumo, proposta_id: propostaId}, state);
        console.log('Proposta enviada PARA cliente: ', envioProposta);
        if (envioProposta) {
          setAlertInfo({ severity: 'success', message: 'Proposta enviada com sucesso!' });
          setShowAlert(true);
        }
      }
      setIsSending(false);
      handleCloseConfirmModal();
    } catch (error) {
      const financeiraId = state.propostaFinanceira?.id;
      const condicaoPagamentoId = state.condicaoPagamento?.id;
      if (!financeiraId) {
        handleCloseConfirmModal();
        setAlertInfo({ severity: 'error', message: 'Proposta financeira não encontrada.' });
        setShowAlert(true);
        setIsSending(false);
        return;
      } else if (!condicaoPagamentoId) {
        handleCloseConfirmModal();
        setAlertInfo({ severity: 'error', message: 'Proposta financeira incompleta.' });
        setShowAlert(true);
        setIsSending(false);
        return;
      } else { 
        handleCloseConfirmModal();
        setAlertInfo({ severity: 'error', message: 'Erro ao enviar a proposta. Verifique os dados.' });
        setShowAlert(true);
        setIsSending(false);
      }
      
    }
  };

  


  useEffect(() => {
    if (idAtendimento) {
      buscarPropostas(idAtendimento, propostaAtivaId ?? undefined);
    }
  }, [idAtendimento]);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      const target = event.target as HTMLElement;
  
      const isSelectDropdown =
      target.closest('.MuiPopover-root') ||
      target.closest('.MuiSelect-select') ||
      target.closest('.MuiFormControl-root') ||
      target.closest('.MuiMenu-paper') ||
      target.closest('.MuiSelect-root') ||
      target.closest('.MuiDivider-root') ||
      target.closest('._proposta_1ctfo_41') ||
      target.tagName === 'HR' ||
      target.classList.contains('MuiDivider-root');

      if (isSelectDropdown) return;
  
      if (
        containerRef.current &&
        !containerRef.current.contains(target)
      ) {
        if (!state.propostaSalva) {
          setOpenModalAviso(true);
        }
      }
    }
  
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [state.propostaSalva]);

  useEffect(() => {
    function handleBeforeUnload(event: BeforeUnloadEvent) {
        if (!state.propostaSalva) {
            event.preventDefault();
            event.returnValue = "Você tem mudanças não salvas. Tem certeza que deseja sair?";
        }
    }

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [state.propostaSalva]);

  

  return (
    <>
      <header className={styles.header_container}>
        {state.propostas.length > 0 ? (
          <FormControl>
          <InputLabel id='proposta' className={styles.proposta_label}>
            Proposta
          </InputLabel>
          <Select
            disabled={state.proposta.estado_pagamento === 'PAGAMENTO_CONFIRMADO'}
            labelId='proposta'
            id='proposta'
            value={state.proposta?.id || ''}
            onChange={async (e) => {
              const idSelecionado = Number(e.target.value);
              const selecionada = state.propostas.find(p => p.id === idSelecionado);
              if (selecionada) {
                const fetchProposta = async () => {
                dispatch({ type: ActionType.RESET_ESTADO });
              }
              await fetchProposta();
              dispatch({ type: ActionType.SET_PROPOSTA, payload: selecionada });
              }
            }}
            className={styles.proposta_select}
            style={{
              color: state.proposta?.id === propostaAtivaLocalId ? 'var(--accent-color-2)' : '',
              alignItems: 'center',
            }}
          >
            <MenuItem value={0}>Selecione uma proposta</MenuItem>
            {state.propostas.map((p) => (
              <MenuItem
                key={p.id}
                value={p.id}
                style={{
                  background:
                    p.id === state.proposta?.id ? 'rgba(233, 119, 95, 0.5)' : '',
                }}
              >
                <div
                  style={{
                    color: p.id === propostaAtivaLocalId ? 'var(--accent-color-2)' : '',
                    fontWeight: 'bold',
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%',
                  }}
                >
                  <div>Proposta Nº {p.numero_proposta}</div>
                  <div>{p.id === propostaAtivaLocalId && <CheckCircleOutlineOutlinedIcon />}</div>
                </div>
              </MenuItem>
            
            ))}
          </Select>
        </FormControl>      
      ) : (
        <div className={styles.empty_component} />
      )}

        <div className={styles.opcoes_acoes}>

          <Button
            className={styles.add_proposta}
            onClick={() => {
              iniciarNovaProposta(parseInt(idAtendimento));
            }}
            variant='contained'
            startIcon={<AddIcon />}
            disabled={state.proposta.estado_pagamento === 'PAGAMENTO_CONFIRMADO'}
          >
            {state.propostas.length > 0 ? 'CRIAR NOVA PROPOSTA' : 'CRIAR PROPOSTA'}
          </Button>

          {state.proposta.id ? (
            <Button
              className={styles.deletar_proposta}
              variant='contained'
              startIcon={<DeleteOutlineIcon />}
              onClick={() => handleOpenConfirmDeleteModal()}
              disabled={state.proposta.estado_pagamento === 'PAGAMENTO_CONFIRMADO'}
            />
          ) : <div></div>}
        </div>
      </header>

      <Divider style={{ marginBottom: '2rem', marginTop: '3rem' }} />

      <>
        {(state.proposta?.atendimento_id) ? (

          <div ref={containerRef} className={styles.container_proposta}> 
             {
               <main className={styles.main}>
                 <div className={styles.container_formulario}>
                   <form>
                      <div className={styles.primeira_etapa}>
                        <div className={styles.campos_formulario}>
                          <div>
                            <TextFieldComponent
                              label="Resumo"
                              name="resumo"
                              width="100%"
                              value={state.proposta.resumo}
                              onChange={(e) => atualizarCampo('proposta', { resumo: e.target.value }, true)}
                              fullWidth
                              height='7vh'
                              titleTop={true}
                              required={true}
                              disabled={state.proposta.estado_pagamento === 'PAGAMENTO_CONFIRMADO'}
                            />
                            {state.errosProposta.resumo && <span className={styles.error}>{state.errosProposta.resumo}</span>}
                          </div>


                          <div className={styles.reactquill_container}>
                            <label className={styles.quill_label}>Descrição</label>
                            <StyledQuill
                              theme="snow"
                              value={DOMPurify.sanitize(state.proposta.descricao)}
                              onChange={(value) => {
                                const novoValor = value;

                                if (novoValor != state.proposta.descricao) {
                                  atualizarCampo('proposta', { descricao: value }, true);
                                }
                                
                                if (novoValor.length > 6000) {
                                  dispatch({ type: ActionType.SET_ERROS_PROPOSTA, payload: { ...state.errosProposta, descricao: '...' } });
                                } else {
                                  dispatch({ type: ActionType.SET_ERROS_PROPOSTA, payload: { ...state.errosProposta, descricao: undefined } });
                                }

                              }}
                              readOnly={state.proposta.estado_pagamento === 'PAGAMENTO_CONFIRMADO'}
                            />
                            {state.errosProposta.descricao && (
                              <span className={styles.error}>{state.errosProposta.descricao}</span>
                            )}
                          </div>


                          <div className={styles.reactquill_container}>
                            <label className={styles.quill_label}>Especificação técnica</label>
                            <StyledQuill
                              theme="snow"
                              value={DOMPurify.sanitize(state.proposta.listagem_itens)}
                              onChange={(value) => {
                                const novoValor = value;

                                if (novoValor != state.proposta.listagem_itens) {
                                  atualizarCampo('proposta', { listagem_itens: value }, true);
                                }

                                if (novoValor.length > 3500) {
                                  dispatch({
                                    type: ActionType.SET_ERROS_PROPOSTA,
                                    payload: {
                                      ...state.errosProposta,
                                      listagem_itens: 'O limite máximo de caracteres é de 3000.',
                                    },
                                  });
                                } else {
                                  dispatch({
                                    type: ActionType.SET_ERROS_PROPOSTA,
                                    payload: {
                                      ...state.errosProposta,
                                      listagem_itens: undefined,
                                    },
                                  });
                                }
                              }}
                              style={{ width: '100%' }}
                              readOnly={state.proposta.estado_pagamento === 'PAGAMENTO_CONFIRMADO'}
                            />
                            {state.errosProposta.listagem_itens && (
                              <span className={styles.error}>{state.errosProposta.listagem_itens}</span>
                            )}
                          </div>


                          <div>
                            <TextFieldComponent
                              type="number"
                              label="Prazo entrega (dias úteis)"
                              name="prazo_entrega"
                              value={state.proposta.prazo_entrega}
                              onChange={(e) => {
                                const value = parseInt(e.target.value);
                                atualizarCampo('proposta', { prazo_entrega: isNaN(value) ? 0 : value }, true);

                                if (isNaN(value) || value <= 0) {
                                  dispatch({
                                    type: ActionType.SET_ERROS_PROPOSTA,
                                    payload: {
                                      ...state.errosProposta,
                                      prazo_entrega: 'Prazo de entrega deve ser maior que zero',
                                    },
                                  });
                                } else {
                                  dispatch({
                                    type: ActionType.SET_ERROS_PROPOSTA,
                                    payload: {
                                      ...state.errosProposta,
                                      prazo_entrega: undefined,
                                    },
                                  });
                                }
                              }}
                              fullWidth
                              width="100%"
                              height="7vh"
                              titleTop={true}
                              required={true}
                              disabled={state.proposta.estado_pagamento === 'PAGAMENTO_CONFIRMADO'}
                            />
                            {state.errosProposta.prazo_entrega && (
                              <span className={styles.error}>{state.errosProposta.prazo_entrega}</span>
                            )}
                          </div>

                          <div>
                            <EnviarImagensComponente
                              enviar={state.enviarImagem}
                              proposta_id={state.proposta?.id ?? 0}
                              classContainerImagem={styles.container_campo_imagem}
                              classDragAndDropArea={styles.drag_and_drop_area}
                              classDescricaoTitulo={styles.descricao_titulo}
                              classImagens={styles.listaImagens}
                              onChangeImagens={(imgs) => {
                                dispatch({ type: ActionType.SET_IMAGENS, payload: imgs });
                                dispatch({ type: ActionType.SET_ERROS_PROPOSTA, payload: { imagens: undefined } });
                              
                                if (alteracaoManualImagens.current) {
                                  atualizarCampo('proposta', {}, true);
                                  alteracaoManualImagens.current = false;
                                }
                              }}                              
                              alteracaoManualRef={alteracaoManualImagens}
                              readonly={state.proposta.estado_pagamento === 'PAGAMENTO_CONFIRMADO'}
                            />
                            {state.errosProposta.imagens && (
                              <span className={styles.error}>{state.errosProposta.imagens}</span>
                            )}
                          </div>

                        </div>


                        <div className={styles.ver_proposta}>
                          <VerPropostaComponente
                            resumo={state.proposta.resumo}
                            descricao={state.proposta.descricao}
                            listaItens={state.proposta.listagem_itens}
                            prazoEntrega={String(state.proposta.prazo_entrega)}
                            valorProposta={state.propostaFinanceira?.valor_proposta}
                            quantidadeParcelas={state.condicaoPagamento?.quantidade_parcela}
                            porcentagem={state.propostaFinanceira?.desconto_em_porcentagem}
                            valorComDesconto={state.propostaFinanceira?.valor_com_desconto}
                            imagens={state.imagens}
                            tipoPagamento={state.condicaoPagamento?.tipo_pagamento}
                            valorEntrada={state.condicaoPagamento?.valor_entrada}
                            descontoEntrada={state.condicaoPagamento?.desconto_entrada}
                            parcelas={[]}
                            id={state.proposta.id}
                            condicaoPagamentoId={state.condicaoPagamento?.id}
                          />
                        </div>
                        
                      </div>

                      <div>
                          <div ref={containerRef}>
                            {state.proposta?.id && state.proposta.id > 0 ? (
                              <PropostaFinanceira
                                propostaId={state.proposta.id}
                                propostaFinanceiraAtivaId={state.proposta.PropostaFinanceiraAtivaId}
                              />
                            ) : (
                              <p className={styles.aviso_salvar_proposta}>
                                <WarningIcon style={{marginBottom: "-0.25rem", marginRight: "0.2rem", color: "#ff0000"}} />
                                Salve a proposta antes de criar uma proposta financeira.
                              </p>
                            )}

                          </div>
                      </div>


                      <div className={styles.botoes}>

                        <Button
                          type="button"
                          style={{ background: state.proposta.estado_pagamento === 'PAGAMENTO_CONFIRMADO' ? 'rgba(0, 0, 0, 0.12)' : 'var(--primary-color)' }}
                          onClick={async () => {
                            handleSalvarProposta();
                          }}
                          endIcon={isSaving && <CircularProgress size={18} sx={{ color: '#fff' }} />}
                          disabled={state.proposta.estado_pagamento === 'PAGAMENTO_CONFIRMADO'}
                        >
                          {isSaving ? 'SALVANDO...' : 'SALVAR PROPOSTA'}
                        </Button>

                        <Tooltip
                          title={!state.propostaSalva ? "Salve a proposta antes de enviar" : ""}                 
                          arrow
                          componentsProps={{
                            tooltip: {
                              sx: {
                                fontSize: '0.9rem',
                              }
                            }
                          }}
                          placement="top"
                          disableHoverListener={state.propostaSalva}
                        >
                          <span>
                            <Button
                              type="button"
                              onClick={handleClickOpenConfirmModal}
                              disabled={isSending || !state.propostaSalva || !state.proposta?.id}
                              endIcon={isSending && <CircularProgress size={18} sx={{ color: '#fff' }} />}
                            >
                              {isSending ? 'ENVIANDO...' : 'ENVIAR PARA CLIENTE'}
                            </Button>
                          </span>
                      </Tooltip>

                      <Button
                        type="button"
                        style={{
                          color: state.proposta.estado_pagamento === 'PAGAMENTO_CONFIRMADO' ? '' : '#F7F7F9',
                          background: state.proposta.estado_pagamento === 'PAGAMENTO_CONFIRMADO'
                            ? 'rgba(0, 0, 0, 0.12)'
                            : 'var(--atendimento-submit-button-color)',
                        }}
                        onClick={handleClickOpenConfirmPaymentModal}
                        disabled={state.proposta.estado_pagamento === 'PAGAMENTO_CONFIRMADO'}
                      >
                        Confirmar Pagamento
                      </Button>




                      </div>


                  </form>

                  <CustomSnackbar
                    open={showAlert}
                    severity={alertInfo.severity}
                    message={alertInfo.message}
                    handleClose={handleAlertClose}
                  />

                  <ConfirmModal
                    open={openConfirmModal}
                    onClose={handleCloseConfirmModal}
                    onConfirm={handleConfirmarEnvio}
                    title="Confirmar envio da proposta"
                    description="Você tem certeza que deseja enviar a proposta para o cliente?"
                    confirmText="Confirmar"
                    cancelText="Cancelar"
                    isLoading={isSending}
                    confirmButtonStyle={{
                      color: '#F7F7F9',
                      backgroundColor: 'var(--primary-color)',
                      '&:hover': { backgroundColor: 'var(--primary-color-dark)' }
                    }}
                    cancelButtonStyle={{
                      color: 'var(--text)',
                      backgroundColor: 'var(--border-color-2)',
                      '&:hover': { backgroundColor: '#aaaaaa' }
                    }}
                  />

                  <ConfirmModal
                    open={openConfirmPaymentModal}
                    onClose={handleCloseConfirmPaymentModal}
                    onConfirm={async () => {
                      if (!pagamentoTipo) {
                        setPagamentoTipoErro(true);
                        return;
                      }

                      setOpenConfirmPaymentModal(false);
                      if (state.proposta.id) {
                        setAlertInfo({ severity: 'success', message: 'Pagamento Confirmado!' });
                        setShowAlert(true);
                        confirmarPagamento(state.proposta.id, "PAGAMENTO_CONFIRMADO", pagamentoTipo);
                      }
                    }}
                    title="Confirmar pagamento"
                    description={"Confirmação de pagamento para proposta do atendimento " + idAtendimento}
                    confirmText="Confirmar"
                    cancelText="Cancelar"
                    confirmButtonStyle={{
                      color: '#F7F7F9',
                      backgroundColor: 'var(--primary-color)',
                      '&:hover': { backgroundColor: 'var(--primary-color-dark)' }
                    }}
                    cancelButtonStyle={{
                      color: 'var(--text)',
                      backgroundColor: 'var(--border-color-2)',
                      '&:hover': { backgroundColor: '#aaaaaa' }
                    }}
                  >

                    {state.proposta.estado_pagamento === 'AGUARDANDO_CONFIRMACAO_PAGAMENTO' && (
                      <div style={{ 
                        backgroundColor: '#FFF3CD', 
                        color: '#856404', 
                        padding: '1rem', 
                        borderRadius: '4px', 
                        marginBottom: '1rem', 
                        border: '1px solid #ffeeba' 
                      }}>
                        <strong>Atenção:</strong> Foi encontrado um pagamento corrente no ASAAS para esta proposta. Deseja mesmo assim prosseguir?
                      </div>
                    )}

                    {/* SELEÇÃO DE FORMA DE PAGAMENTO */}
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '1rem', justifyContent: 'center', alignItems: 'center', marginTop: '1rem' }}>
                      <span style={{ color: 'var(--text)' }}>Forma de pagamento:</span>
                      <VivaTextField
                        label="Forma de pagamento"
                        name="pagamentoTipo"
                        value={pagamentoTipo}
                        required
                        width='15rem'
                        onBlur={() => setPagamentoTipoErro(!pagamentoTipo)}
                        customField={() => (
                          <TextField
                            select
                            label=""
                            value={pagamentoTipo || "Selecione"}
                            onChange={(e) => {
                              setPagamentoTipo(e.target.value);
                              setPagamentoTipoErro(false);
                            }}
                            error={pagamentoTipoErro}
                            SelectProps={{
                              displayEmpty: true,
                              renderValue: pagamentoTipo !== "" ? undefined : () => "Selecione",
                            }}
                          >
                            <MenuItem value="FINANCIADO">Financiado</MenuItem>
                            <MenuItem value="DINHEIRO">Dinheiro</MenuItem>
                            <MenuItem value="MAQUININHA">Maquininha</MenuItem>
                            <MenuItem value="TRANSFERENCIA">Transferência</MenuItem>
                          </TextField>
                        )}
                      />
                    </div>

                    {pagamentoTipoErro && <span style={{ color: 'red', fontSize: '0.8rem', textAlign: 'center' }}>Selecione uma forma de pagamento</span>}
                  </ConfirmModal>
                      
                  <ConfirmModal
                    open={openConfirmDeleteModal}
                    onClose={handleCloseConfirmDeleteModal}
                    onConfirm={handleConfirmDelete}
                    title="Confirmar exclusão"
                    description="Você tem certeza que deseja excluir esta proposta? Esta ação não pode ser desfeita."
                    confirmText="Confirmar"
                    cancelText="Cancelar"
                    confirmButtonStyle={{
                      color: '#F7F7F9',
                      backgroundColor: 'var(--primary-color)',
                      '&:hover': { backgroundColor: 'var(--primary-color-dark)' },
                    }}
                    cancelButtonStyle={{
                      color: 'var(--text)',
                      backgroundColor: 'var(--border-color-2)',
                      '&:hover': { backgroundColor: '#aaaaaa' },
                    }}
                  />

                  <Dialog
                      open={openModalAviso}
                      onClose={() => setOpenModalAviso(false)}
                  >
                    <DialogTitle>Atenção</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Você tem mudanças não salvas na proposta do atendimento {idAtendimento}. Deseja salvar antes de sair?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button
                          className={styles.botao_secundario}
                          variant="outlined"
                          onClick={() => {
                            dispatch({ type: ActionType.SET_PROPOSTA_SALVA, payload: true });
                            setOpenModalAviso(false);
                          }}
                      >
                          Continuar sem salvar
                      </Button>

                      <Button
                          className={styles.botao_primario}
                          variant="contained"
                          onClick={() => {
                              handleSalvarProposta();
                              setOpenModalAviso(false);
                          }}
                      >
                          Salvar
                      </Button>
                    </DialogActions>
                  </Dialog>




                </div>
              </main>
            }
          </div>
        ) : <div></div>}
      </>
    </>
  )
}
